import { filter, flow, get, head, map } from 'lodash/fp'

export const getFirst = (obj, keys = []) => {
  return flow(
    map((key) => get(key)(obj)),
    filter((v) => v != null),
    head,
  )(keys)
}
